import React from 'react';
import PropTypes from 'prop-types';

import { DemoPage } from '../../partials';

// Import code snippets as text.
const html = require('!raw-loader!flexbox-patterns/src/examples/side-bar.html');
const css = require('!raw-loader!flexbox-patterns/src/styles/side-bar.css');
const js = require('!raw-loader!./sideBar.js');

export const SideBarDemo = ({ name }) => (
  <DemoPage title={name} html={html} css={css} js={js}>
    <p>
      Here&rsquo;s a pretty typical navigation component. You don&rsquo;t even
      need flexbox to build something like this, just divs alone would be enough
      &hellip; unless you want to position those &ldquo;Change theme&rdquo; and
      &ldquo;Legal&rdquo; buttons down at the bottom. You could do this with
      absolute positioning, but flexbox works well, too.
    </p>

    <p>
      By now you&rsquo;re probably familiar with
      <code>display: flex</code> and
      <code>justify-content: space-between</code>. In addition to these
      we&rsquo;ll need one more property:
    </p>

    <ul>
      <li>
        <code>flex-direction: column</code> sets the main axis to be vertical
        instead of horizontal. As you may guess, this now lays out the children
        vertically instead of horizontally.
      </li>
    </ul>
  </DemoPage>
);

SideBarDemo.propTypes = {
  name: PropTypes.string.isRequired,
};



// WEBPACK FOOTER //
// ./ui/views/demos/SideBarDemo.js